/**
 * Исходники лежат в гитхабе
 * @see https://github.com/neomasterr/privettur-join-landing
 */

import './bundle/app';
import './bundle/main';

document.querySelectorAll('.acc-head').forEach(function(button){
    button.addEventListener('click', function() {
        const item = button.closest('.acc-item');
        item.classList.toggle('open');
    });
});

document.querySelectorAll('.switch').forEach(function(button){
    button.addEventListener('click', function() {
        document.querySelectorAll('.switch').forEach(function(btn){
            btn.classList.remove('active');
        });
        button.classList.add('active');
    });
});